import {
  Card,
  CardBody,
  Content,
  FontAwesomeProIcon,
  Heading,
} from '@wienenergiegithub/ui-next';
import styles from './HeatFacts.module.scss';
import React from 'react';
import PropTypes from 'prop-types';

const HeatFacts = ({ className }) => (
  <Card className={className}>
    <CardBody>
      <Heading as="h3" size="h5">
        2 Fakten zum Heizen
      </Heading>
      <div className={styles.container}>
        <div className={styles.element}>
          <FontAwesomeProIcon
            className={styles.icon}
            icon="thermometer-three-quarters"
            role="presentation"
            type="regular"
          />
          <Heading as="h4" noSpacing size="h5">
            1 °C
          </Heading>
          <Content align="center" noSpacing size="regular">
            1 °C weniger Raumtemperatur spart bis zu 6 % Heizkosten
          </Content>
        </div>
        <div className={styles.element}>
          <FontAwesomeProIcon
            className={styles.icon}
            icon="home"
            role="presentation"
            type="solid"
          />
          <Heading as="h4" noSpacing size="h5">
            Sonne tanken
          </Heading>
          <Content align="center" noSpacing size="regular">
            Jalousine, Rollos, und Vorhänge nachts schließen und tagsüber öffnen
            spart Heizkosten
          </Content>
        </div>
      </div>
    </CardBody>
  </Card>
);

HeatFacts.propTypes = {
  className: PropTypes.string,
};

export { HeatFacts };
